import { render, staticRenderFns } from "./CustomerChangelog.vue?vue&type=template&id=d5da9046&scoped=true&lang=pug&"
import script from "./CustomerChangelog.vue?vue&type=script&lang=js&"
export * from "./CustomerChangelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5da9046",
  null
  
)

export default component.exports